<template>
  <rest
    :remote="remote"
    :table-columns="tableColumns"
    :formInitialize="formInitialize"
    :form-rules="formRules"
    :exportable="true"
    :create-able="true" :update-able="true" :delete-able="true"
  >
  </rest>
</template>

<script>
import Rest from '@/components/Spring/Rest.vue'
export default {
  name: 'wikiVpcs',
  components: { Rest },

  data () {
    return {
      remote: {
        path: 'channel',
        resource: this.$options.name,
        realtime: true
      },
      formInitialize: {
        seq: 0
      },
      formRules: {
        vpc: [{ required: true, message: '请填写 VPC' }],
        region: [{ required: true, message: '请填写 地区' }],
        isp: [{ required: true, message: '请填写 服务商' }],
        company: [{ required: true, message: '请填写 公司' }]
      }
    }
  },
  computed: {
    tableColumns () {
      return [
        { label: 'ID', prop: 'id', hiddenForm: true },
        { label: '序号', prop: 'seq' },
        { label: 'VPC', prop: 'vpc' },
        { label: '子网', prop: 'subnet' },
        { label: '地区', prop: 'region' },
        { label: '服务商', prop: 'isp' },
        { label: '公司', prop: 'company' },
        { label: '备注', prop: 'note', type: 'textarea' }
        // { label: '创建时间', prop: 'createdAt', type: 'datetime', hiddenForm: true },
        // { label: '修改时间', prop: 'updatedAt', type: 'datetime', hiddenForm: true }
      ]
    }
  },
  methods: {
  }
}
</script>

<style scoped>
</style>
